import { useMemo } from 'react';
export function useIsSafeExamBrowser(): boolean {
	const isSafeExamBrowser: boolean = useMemo(() => {
		return (window as any).SafeExamBrowser !== undefined;
	}, []);

	return isSafeExamBrowser;
}
